import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Header, MobileNav, DesktopNav } from '@components';

import './header-container.scss';

import { menuItems } from '../../../data/constants';

const HeaderContainer = (props) => {
  const { children } = props;
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const toggleNav = () => {
    setMobileNavOpen(!mobileNavOpen);
  };

  return (
    <Header {...props}>
      <div className={cs('on-hamburger-menu-wrapper', 'd-md-none')} onClick={toggleNav}>
        <FontAwesomeIcon icon="bars" className={cs('on-hamburger-menu', 'd-inline', 'd-md-none')} />
      </div>

      <a className="logo-compass" href="https://truelocalrealty.com/" aria-label="Compass logo link">
        <img
          className="cb-image"
          src="https://assets.thesparksite.com/uploads/sites/834/2019/09/TL-Compass-Logo-Lockup-Transparent-WHITE-AUTOx60.fit.png"
          srcSet="https://assets.thesparksite.com/uploads/sites/834/2019/09/TL-Compass-Logo-Lockup-Transparent-WHITE-AUTOx120.fit.png 2x"
          alt="TL-&amp;#038;-Compass-Logo-Lockup-Transparent-WHITE"
        />
      </a>

      <MobileNav items={menuItems} className="on-mobile-menu" isOpen={mobileNavOpen} toggleNav={toggleNav} />
      <DesktopNav items={menuItems} className="on-desktop-menu" />

      <a href="https://truelocalrealty.com/contact-us/" className="button button-compass">
        Talk To An Expert
      </a>

      {children}
    </Header>
  );
};

HeaderContainer.propTypes = {
  children: PropTypes.node,
};

HeaderContainer.defaultProps = { children: null };

export default memo(HeaderContainer);
